<template>
  <div id="app" style="text-align: center;justify-content: center;align-items: center;display: flex;">
    <!-- <img src="../assets/loadlogo.png" style="width: 20%;" /> -->
  </div>
</template>

<script>
import { getWxUser } from '@/api/public';
export default {
  name: 'load',
  data() {
    return {
      no_channel: false,
    };
  },
  methods: {},
  created() {
    if (!localStorage.getItem('auth')) {
      let searchURL = window.location.search;
      let code = '';

      if (searchURL) {
        searchURL = searchURL.substring(1, searchURL.length);
        code = searchURL.split('&')[0].split('=')[1];
      }
      if (!code) {
        window.location.href =
          'https://open.weixin.qq.com/connect/oauth2/authorize?appid=ww70fd72735961d8b1&redirect_uri=https://fcpg.shnsshrcb.com&response_type=code&scope=snsapi_privateinfo&state=STATE&agentid=1000039#wechat_redirect';
      } else {
        getWxUser(code)
          .then((res) => {
            debugger;
            localStorage.setItem('auth', res.data);
            window.location.href = 'https://fcpg.shnsshrcb.com/index';
            // this.$router.push('/index');
          })
          .catch((e) => {
            console.log(e);
          });
      }
    } else {
      window.location.href = 'https://fcpg.shnsshrcb.com/index';
    }
  },
};
</script>


